import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSidebarStore = defineStore('sidebar', () => {
  // State
  const isCollapsed = ref(false)
  const isMobileMenuOpen = ref(false)

  // Load collapsed state from localStorage
  const storedState = localStorage.getItem('sidebar-collapsed')
  if (storedState !== null) {
    isCollapsed.value = storedState === 'true'
  }

  // Actions
  function toggleCollapse() {
    isCollapsed.value = !isCollapsed.value
    localStorage.setItem('sidebar-collapsed', isCollapsed.value.toString())
  }

  function setCollapsed(collapsed: boolean) {
    isCollapsed.value = collapsed
    localStorage.setItem('sidebar-collapsed', collapsed.toString())
  }

  function toggleMobileMenu() {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
  }

  function openMobileMenu() {
    isMobileMenuOpen.value = true
  }

  function closeMobileMenu() {
    isMobileMenuOpen.value = false
  }

  return {
    isCollapsed,
    isMobileMenuOpen,
    toggleCollapse,
    setCollapsed,
    toggleMobileMenu,
    openMobileMenu,
    closeMobileMenu
  }
})
